import api from './api';

const state = {
	error: null,
	drivers: [],
	days: [],
	statistics: {},
	currency: 'CHF',
	total: {},
	plugins: [],
};

const getters = {
	total: (state, getters, rootState, rootGetters) => {
		return state.total;
	},
};

const mutations = {
	setError(state, { error }) {
		state.error = error;
	},

	setDrivers(state, { drivers, extraPayAccounts = [] }) {
		state.drivers = drivers;

		const customExtraPay = {};
		const total = { ...state.total };
		for (const account of extraPayAccounts) {
			customExtraPay[account.number] = 0;
		}

		for (const driver of drivers) {
			total[driver.id] = { night1: 0, night2: 0, saturday: 0, sunday: 0, total: 0, ...customExtraPay };
		}

		state.total = total;
	},

	setDays(state, days) {
		state.days = days.filter((day) => state.statistics[day.id] !== undefined);
	},

	setStatistics(state, { statistics, extraPayAccounts = [] }) {
		let previousDay = null;
		const customExtraPay = {};
		for (const account of extraPayAccounts) {
			customExtraPay[account.number] = 0;
		}

		const currentTotal = JSON.parse(JSON.stringify(state.total));
		const currentStatistics = JSON.parse(JSON.stringify(state.statistics));

		for (const driver of state.drivers) {
			currentTotal[driver.id] = { night1: 0, night2: 0, saturday: 0, sunday: 0, total: 0, ...customExtraPay };
		}
		for (const statistic of statistics) {
			if (previousDay !== statistic.day) {
				currentStatistics[statistic.day] = {};
				previousDay = statistic.day;
			}
			currentStatistics[statistic.day][statistic.user] = statistic;

			currentTotal[statistic.user].night1 += statistic.extraPayNight1;
			currentTotal[statistic.user].night2 += statistic.extraPayNight2;
			currentTotal[statistic.user].saturday += statistic.extraPaySaturday;
			currentTotal[statistic.user].sunday += statistic.extraPaySunday;

			if (extraPayAccounts.length && statistic.customExtraPay) {
				for (const account of extraPayAccounts) {
					if (statistic.customExtraPay[account.number] != null) {
						currentTotal[statistic.user][account.number] += statistic.customExtraPay[account.number];
					}
				}
			}

			currentTotal[statistic.user].total += statistic.extraPayNight1 + statistic.extraPayNight2 + statistic.extraPaySaturday + statistic.extraPaySunday;
		}
		state.statistics = currentStatistics;
		state.total = currentTotal;
	},

	setCurrency(state, currency) {
		state.currency = currency;
	},

	setPlugins(state, plugins) {
		state.plugins = plugins;
	},
};

const actions = {
	async loadDrivers({ commit, rootState }) {
		try {
			const drivers = (await api.getDrivers()).data;
			commit('setDrivers', { drivers, extraPayAccounts: rootState.setup?.setup?.extraPay_accounts });
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async loadDays({ commit }, { from, to }) {
		try {
			const days = (await api.getDays(from, to)).data;
			commit('setDays', days);
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async loadStatistics({ commit, rootState }, { users, from, to }) {
		try {
			const statistics = (await api.getStatistics(users, from, to)).data;
			commit('setStatistics', { statistics, extraPayAccounts: rootState.setup?.setup?.extraPay_accounts });
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
	async loadCurrency({ commit }) {
		try {
			const result = await api.getCurrency();
			commit('setCurrency', result.data);
		} catch (err) {
			commit('setError', { error: err.response.data.message });
		}
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
